import React, {ReactElement, useState} from 'react';
import {
  Divider,
  makeStyles,
  Typography,
  Theme,
  createStyles,
  Button
} from '@material-ui/core';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {Drawer} from '@material-ui/core';
import {Subscription} from 'rxjs';

// styles
import './DrawerComponentStyles.scss';
import {
  DEFAULT_WHITE_COLOR,
  BORDER_COLOR,
  APP,
  APP_PRIMARY_COLOR,
  PAYMENTS_BACKGROUND_COLOR,
  FONT_SECONDARY_COLOR
} from 'src/style/variable';
import {AppPermissions} from '@shared/constants/Mapping';
import {useTranslation} from 'react-i18next';
import {Permission} from '@shared/services/PermissionService';
import GuarantorDetailsCard from '../../Patients/Patientdetails/GuarantorDetailsCard/GuarantorDetailsCard';
import PatientPaymentsCard from '../../Patients/Patientdetails/PaymentsCard/PatientPaymentsCard';
import NotificationHistoryCard from '../../Patients/Patientdetails/NotificationHistoryCard/NotificationHistoryCard';
import PatientActivityCard from '../../Patients/Patientdetails/PatientActivityCard/PatientActivityCard';
import {useDispatch, useSelector} from 'react-redux';
import HelperUtils from '@shared/utils/HelperUtils';
import {getGuarantor} from '@shared/services/PatientsServices';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import Loader from '@components/framework/loader/Loader';
import {getAllClinics} from '@shared/services/ClinicServices';
import AddPatient from '../../Patients/AddPatient/AddPatient';
import {_setClinics} from '@shared/store/actions/ClinicActions';
import AllPaymentPlansCard from './AllPaymentPlansCard/AllPaymentPlansCard';
import {_patientDrawerDetails} from '@shared/store/actions/PatientDrawerAction';
import BalancesLocationCard from '../../Patients/Patientdetails/BalancesLocationCard/BalancesLocationCard';
import MinGridTable, {
  ColumnDef
} from '@components/system/MinGridTable/MinGridTable';
import {CommunicationService} from 'src/service/CommunicationService';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent'
      },
      '& .MuiDrawer-paperAnchorRight': {
        width: '90%',
        height: '-webkit-fill-available',
        backgroundColor: DEFAULT_WHITE_COLOR,
        marginTop: theme.mixins.toolbar.minHeight,
        zIndex: 1300,
        borderLeft: `1px solid ${BORDER_COLOR}`
      }
    },
    DrawerInfo: {
      paddingBottom: '1rem',
      paddingTop: '1rem',
      fontSize: '1.3rem',
      fontWeight: 600
    },
    sectionRow: {
      display: 'grid',
      gridTemplateColumns: '100%',
      fontSize: '1.3rem'
    },
    paymentNote: {
      paddingBottom: '1rem'
    },
    DetailsView: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.3rem',
      rowGap: '1rem',
      overflowY: 'auto',
      maxHeight: '15.5rem'
    },
    DetailRow: {
      display: 'grid',
      gridTemplateColumns: '35% 10% 55%',
      fontSize: '1.3rem'
    },
    DetailName: {
      fontSize: '1rem',
      color: '#54585b',
      maxWidth: '15rem',
      overflowWrap: 'break-word'
    },
    DetailValue: {
      fontSize: '1rem',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    },
    alignItems: {
      alignItems: 'center'
    },
    rowMargin: {
      marginTop: '1rem'
    },
    flexWrap: {
      flexWrap: 'wrap'
    },
    displayFlex: {
      display: 'flex'
    },
    title: {
      margin: '16px 0 8px',
      fontSize: 16
    },
    PatientDetailsMainView: {
      flexDirection: 'row',
      display: 'flex'
    },
    PatientDetailsMainViews: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '0.1rem',
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem'
    },
    PatientDetailHeaderValue: {
      color: APP.STATUS.DEFAULT,
      fontSize: '1rem'
    },
    PatientDetailHeaderValues: {
      color: APP.STATUS.DEFAULT,
      fontSize: '1rem',
      paddingLeft: '1.9rem'
    },
    textOverFlow: {
      fontSize: '1rem',
      textOverflow: 'ellipsis',
      overflowWrap: 'break-word'
    },
    PatientDetailAtViewName: {
      width: '30%'
    },
    PatientDetailAt: {
      width: '30%'
    },
    applyOddColor: {
      backgroundColor: 'rgb(0,0,0,0.05)'
    },
    applyEvenColor: {
      backgroundColor: DEFAULT_WHITE_COLOR
    },
    primaryTextColor: {
      color: APP_PRIMARY_COLOR
    },
    patientNameStyles: {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        color: PAYMENTS_BACKGROUND_COLOR
      }
    },
    cardRoot: {
      '& .MuiCardContent-root:last-child': {
        paddingBottom: '5px'
      }
    },
    addPatient: {
      fontSize: '1rem',
      lineHeight: '1rem',
      cursor: 'pointer',
      color: APP_PRIMARY_COLOR,
      paddingLeft: '1rem',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    addPatientWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    verticalDivider: {
      height: 'auto',
      marginLeft: '1rem',
      marginRight: '1rem'
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      paddingInline: '1rem'
    },
    moreFilters: {
      height: '2.3rem',
      width: '5rem',
      lineHeight: '1rem',
      borderColor: APP_PRIMARY_COLOR,
      color: DEFAULT_WHITE_COLOR,
      fontSize: '1rem',
      backgroundColor: APP_PRIMARY_COLOR,
      '&:hover': {
        backgroundColor: APP_PRIMARY_COLOR
      }
    },
    DrawerHeader: {
      fontSize: '2rem',
      padding: '1rem 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      zIndex: 1,
      top: '0',
      backgroundColor: 'white',
      borderBottom: '1px solid lightgray'
    },
    patientNamePadding: {
      padding: '0.8rem'
    },
    emrIdPadding: {
      paddingLeft: '1.9rem'
    },
    patientDataStyle: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    },
    loaderStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    guarantorDrawerWidth: {
      width: '50%',
      paddingBottom: '1.5rem'
    },
    noPatientsData: {
      textAlign: 'center',
      paddingBottom: '9px'
    },
    ClinicNameStyle: {
      color: FONT_SECONDARY_COLOR,
      fontSize: '1.1rem',
      paddingLeft: '0.3rem'
    },
    titlePadding: {
      paddingBloack: '1rem'
    },
    drawerWrapper: {
      paddingInline: 0,
      '& .content-view .header-and-close-section': {
        paddingInline: '1rem'
      }
    }
  })
);

// FIXME: ADD INTERFACE FOR THE PROPS
const GuarantorDrawerComponent = (props: any): ReactElement => {
  const classes = styles();
  const {
    open,
    closeDrawer,
    guarantorId,
    guarantorName,
    clinicId,
    resetPagesInGrid,
    patientDrawerLinkBoolean,
    showEmrSyncActions = true
  } = props;

  const [guarantorInfo, setGuarantorInfo]: any = useState([]);

  const userPermissions = useSelector(
    (state: any) => state.auth.userPermissions
  );
  const groupId: any = useSelector((state: any) => state.auth.groupId);
  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const consolidatedBillingGroupEnable: boolean = useSelector(
    (state: any) => state.clinics.consolidatedBillingGroupEnable
  );

  const selectedClinicLabel = useSelector(
    (state: any) => state.clinics.selectedClinicLabel || ''
  );

  const allClinics: any[] = useSelector((state: any) => state?.clinics?.list);
  const selectedClinic = allClinics?.find(clinic => clinic.id === clinicId);

  const clinicLabel = selectedClinicLabel?.[0] ?? selectedClinic?.name ?? '';
  const {t} = useTranslation();

  const {enqueueSnackbar} = useSnackbar();
  const dispatch = useDispatch();
  const [load, setLoad] = useState<boolean>(true);

  const [clinics, setClinics]: any = useState([]);

  const [openAddPatientDialog, setOpenAddPatientDialog] = useState<boolean>(
    false
  );

  const patientShared = useSelector(
    (state: any) => state.clinics.patientShared
  );
  const [forceUpdate, setForceUpdate] = useState<number>(0);

  const subscription = React.useRef<Subscription>();

  // Guarantor API is called, But Using only Patient response under that Guarantor here .//
  const resolvedClinicId =
    acOfClinics[0] ??
    clinicId ??
    (patientShared ? allClinics?.[0]?.id : undefined);

  const fetchGuarantorDetails = async () => {
    if (guarantorId && resolvedClinicId) {
      getGuarantor(groupId, guarantorId, resolvedClinicId)
        .then(async res => {
          if (res && res?.data) {
            setGuarantorInfo(res?.data?.patient);
          }
        })
        .catch(err => {
          enqueueSnackbar(
            (err && err.message) || t('PATIENTS.GET_PATIENT_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
        })
        .finally(() => {
          setLoad(false);
        });
      return;
    }
    if (guarantorId) {
      setLoad(false);
      enqueueSnackbar(
        t('PATIENTS.SELECT_CLINIC_FOR_FILTER'),
        SnackBarConfig('e')
      );
    }
  };

  React.useEffect(() => {
    fetchGuarantorDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guarantorId, resolvedClinicId]);

  React.useEffect(() => {
    // if there is an update available and no state passed
    subscription.current = CommunicationService.getEvent().subscribe(data => {
      if (
        data.action === 'GUARANTOR_PAYMENT_COMPLETED' ||
        data.action === 'PATIENT_COPAY_ADDED'
      ) {
        setForceUpdate(forceUpdate + 1);
      }
    });
    return () => {
      subscription.current?.unsubscribe();
    };
    // eslint-disable-next-line
  }, []);

  const closePopUp = (): void => {
    if (typeof closeDrawer === 'function') {
      closeDrawer();
    }
  };

  const patientDataColDef: ColumnDef<any>[] = [
    {
      label: t('PAYMENT_HISTORY.PATIENT.NAME'),
      render(item: any) {
        if (patientDrawerLinkBoolean) {
          return (
            <div className={[classes.textOverFlow].join(' ')}>
              {`${
                HelperUtils.commaSeparatedFullName(
                  item.first_name,
                  item.last_name
                ) ?? ''
              }`}
            </div>
          );
        }
        return (
          <div
            className={[
              // classes.PatientDetailAtView,
              classes.textOverFlow,
              classes.primaryTextColor,
              classes.patientNameStyles
            ].join(' ')}
            onClick={() => {
              dispatch(
                _patientDrawerDetails(groupId, resolvedClinicId, item?.id)
              );
            }}
            data-test-id="pcl-statements-patientName">
            {`${
              HelperUtils.commaSeparatedFullName(
                item.first_name,
                item.last_name
              ) ?? ''
            }`}
          </div>
        );
      }
    },
    {
      label: t('PAYMENT_HISTORY.PATIENT.ACCOUNT_NB'),
      render(item: any) {
        return item.emr_id;
      }
    }
  ];

  const openCloseAddPatientDialog = (response?: string) => {
    setOpenAddPatientDialog(!openAddPatientDialog);
    setForceUpdate(forceUpdate + 1);

    if (response === 'confirm') {
      fetchGuarantorDetails();
    }
  };

  const getClinicsOfGroup = async (): Promise<void> => {
    try {
      const res: any = await getAllClinics(groupId);
      if (res && res?.data?.rows?.length) {
        dispatch(_setClinics(res.data.rows));
        setClinics(res?.data?.rows);
      }
      openCloseAddPatientDialog();
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
    }
  };
  return (
    <Drawer
      disableEnforceFocus
      anchor={'right'}
      open={open}
      className={[classes.drawer].join(' ')}
      onClose={() => {
        closePopUp();
      }}
      style={{zIndex: 1200}}>
      {load ? (
        <div className={classes.loaderStyle}>{<Loader />}</div>
      ) : (
        <div className={`drawer-component-wrapper ${classes.drawerWrapper}`}>
          <div className="content-view">
            {/* header and close section start */}
            <div className={`header-and-close-section`}>
              <div
                className="header-view"
                data-test-id="pcl-payments-guarantorHeader">
                <span>{guarantorName}</span>
                <span className={classes.ClinicNameStyle}>
                  {!consolidatedBillingGroupEnable && clinicLabel !== ''
                    ? `(${clinicLabel})`
                    : ''}
                </span>
              </div>
              <Button
                data-test-id="pcl-statements-closeDrawer"
                color="primary"
                variant="outlined"
                className={classes.moreFilters}
                onClick={(): void => closePopUp()}>
                {t('COMMON.CLOSE')}
              </Button>
            </div>
            {/* header and close section end*/}
            <div className={classes.container}>
              {/* left section **/}
              <div className={classes.guarantorDrawerWidth}>
                <GuarantorDetailsCard
                  guarantorId={guarantorId}
                  clinicId={resolvedClinicId}
                  resetPagesInGrid={resetPagesInGrid}
                  forceUpdate={forceUpdate}
                  showEmrSyncActions={showEmrSyncActions}
                />
                <Typography
                  data-test-id="pcl-payments-patientDrawerTitle"
                  className={[
                    classes.DrawerInfo,
                    classes.addPatientWrapper
                  ].join(' ')}
                  component={'div'}>
                  {t('PATIENTS.TITLE_HEADER')}
                  {
                    // ** Permission added to show add patient in Guarantor Drawer Component **/
                    Permission.hasPatientPermissions(
                      userPermissions,
                      AppPermissions.PATIENT.IMPORT,
                      groupId
                    ) && (
                      <Typography
                        className={classes.addPatient}
                        component={'div'}
                        onClick={() => {
                          getClinicsOfGroup();
                        }}>
                        {t('ADD_PATIENT.ADD_PATIENT')}
                      </Typography>
                    )
                  }
                </Typography>
                <MinGridTable
                  rows={guarantorInfo}
                  colDefs={patientDataColDef}
                  noDataText={t('PATIENTS_TAB_NO_PATIENTS')}
                  isLoading={load}
                />
                {Permission.hasStatementPermissions(
                  userPermissions,
                  AppPermissions.STATEMENT.LIST,
                  groupId
                ) && (
                  <div>
                    <PatientActivityCard
                      guarantorId={guarantorId}
                      clinicId={resolvedClinicId}
                    />
                  </div>
                )}
                {Permission.hasNotificationHistoryPermissions(
                  userPermissions,
                  AppPermissions.NOTIFICATION_HISTORY?.LIST,
                  groupId
                ) &&
                  Permission.hasStatementPermissions(
                    userPermissions,
                    AppPermissions.STATEMENT.LIST,
                    groupId
                  ) && (
                    <div>
                      <NotificationHistoryCard
                        guarantorId={guarantorId}
                        clinicId={resolvedClinicId}
                      />
                    </div>
                  )}
              </div>
              <Divider
                orientation={'vertical'}
                className={classes.verticalDivider}
              />
              {/* right section */}
              <div className={classes.guarantorDrawerWidth}>
                {/* Balances Location Component it shown when billing clinic_id is present*/}

                {Permission.hasStatementPermissions(
                  userPermissions,
                  AppPermissions.STATEMENT.LIST,
                  groupId
                ) && (
                  <div>
                    <BalancesLocationCard
                      guarantorId={guarantorId}
                      clinicId={resolvedClinicId}
                      // ADDED TO UPDATE COMPONENT AFTER TAKE PAYMENT COMPLETE
                      key={forceUpdate}
                      resetPagesInGrid={() => {
                        setForceUpdate(forceUpdate + 1);
                      }}
                    />
                  </div>
                )}

                {Permission.hasPaymentHistoryPermissions(
                  userPermissions,
                  AppPermissions.PAYMENT_HISTORY?.LIST,
                  groupId
                ) && (
                  <PatientPaymentsCard
                    guarantorId={guarantorId}
                    clinicId={resolvedClinicId}
                    // ADDED TO UPDATED COMPONENT TO SHOW PAYMENT HISTORY RECORDS AFTER TAKE PAYMENT
                    forceUpdate={forceUpdate}
                    isGuarantorDrawer
                  />
                )}
                {Permission.hasPaymentPlanPermissions(
                  userPermissions,
                  AppPermissions.PAYMENT_PLAN?.LIST,
                  groupId
                ) && <AllPaymentPlansCard guarantorId={guarantorId} />}
              </div>
            </div>
          </div>

          {openAddPatientDialog && (
            <AddPatient
              open={openAddPatientDialog}
              onClose={(response: string) => {
                openCloseAddPatientDialog(response);
              }}
              clinicGroupId={groupId}
              fromEdit={false}
              patientsShared={!patientShared}
              guarantorId={guarantorId}
              addPatientToGuarantor={true}
              clinics={clinics}
              clinicId={resolvedClinicId}
            />
          )}
        </div>
      )}
    </Drawer>
  );
};

export default GuarantorDrawerComponent;
